import { Navigate, Route, Routes } from 'react-router-dom';
import TripExport from './Export/ExportTrip';
import TripChat from './Chat';
import TripReceipt from './Receipt';
import { useApp } from 'hooks';
import { getTravelDiarySettings } from 'api/travelDiarySettings';

const TripsRoutes = () => {
  const { locales } = useApp();

  return (
    <Routes>
      <Route index element={<Navigate to="/trip-designer" replace />} />
      <Route
        path="/:tripId/export"
        element={
          <TripExport
            locales={locales}
            getTravelDiarySettings={getTravelDiarySettings}
          />
        }
      />
      <Route path="/:tripId/receipt" element={<TripReceipt />} />
      <Route path="/:tripId/chat" element={<TripChat />} />
    </Routes>
  );
};

export default TripsRoutes;
